import type { Input, Textarea } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import type { ControllerRenderProps, FieldValues } from "react-hook-form";

type CountedTextInputProps = {
  max: number;
  placeholder?: string;
  Input: typeof Input | typeof Textarea;
} & Partial<ControllerRenderProps<FieldValues, string>>;

export function CountedTextInput({
  max,
  value,
  Input,
  ...rest
}: CountedTextInputProps) {
  return (
    <>
      <Input {...rest} value={value} maxLength={max} />
      <Text color={"gray.600"} fontSize={"sm"} mt={2}>
        {value?.length ?? 0}/{max}
      </Text>
    </>
  );
}
